import { FamilyHome } from "../FamilyHome.jsx";

function BioFamilySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Biology as systems, not vocabulary
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Biology is famously taught as a wall of unfamiliar terminology — DNA,
        codon, ribosome, hippocampus, vena cava, ten thousand more. Students
        who do well never try to memorize the wall. They learn the systems
        the words describe, and the words attach themselves to the structure
        afterward. NerdBio games are built around the systems: how DNA
        actually codes for proteins, how anatomical structures actually relate
        to each other. The vocabulary becomes a side effect of understanding,
        not the goal itself.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Seven games, seven angles on biology
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Gene Pool teaches the genetic code by depth — codons, start and stop
        signals, the wobble at the third position. Anatomy Park teaches
        anatomy by depth — systems, then regions, then structures, then
        functions. Both use spaced repetition so what you learn doesn't
        decay between study sessions.
      </p>
      <p style={{ margin: "0 0 16px" }}>
        Pedigree teaches inheritance patterns from family trees — autosomal
        dominant, autosomal recessive, X-linked, mitochondrial. Phase Lab
        drives a cell through mitosis and meiosis so the phases become
        steps you've performed, not terms you've memorized. Selection
        Pressure shows evolution as Hardy-Weinberg violated — selection,
        drift, migration, mutation — by letting you push a population
        and watch the allele frequencies move.
      </p>
      <p style={{ margin: "0 0 16px" }}>
        Codon Reader has you find open reading frames in an mRNA strand,
        translate codons to proteins, and classify mutations as silent,
        missense, or nonsense. Membrane has you move ions across the
        lipid bilayer using pumps, channels, and gradients — Skou's
        sodium-potassium pump and Mitchell's chemiosmosis become things
        you've operated, not facts you've read.
      </p>
    </>
  );
}

export default function BioHome() {
  return <FamilyHome familyId="bio" seoContent={<BioFamilySeo />} />;
}
